import React from 'react';
import FontAwesome from 'react-fontawesome';
import {Link} from 'react-router';

import AdminTitle from '../../components/AdminTitle';
import Api from '../../Api';

import moment from 'moment';

import './Orders.less';

export default class Orders extends React.Component {
  constructor(props) {
    super(props);

    this.onChange = this.onChange.bind(this);

    this.state = {
      ordersResponse: {
        orders: [],
        retailers: {},
        users: {},
        products: {},
        brands: {}
      },
      error: null,
      retailerFilter: null,
      brandFilter: null
    };
  }

  componentDidMount() {
    this.reloadOrders();
  }

  reloadOrders() {
    this.setState({
      ordersResponse: {
        orders: [],
        retailers: [],
        users: [],
        products: {},
        brands: {}
      }
    });
    this.loadOrders();
  }

  loadOrders(paginationToken) {
    let currentOrdersResponse = this.state.ordersResponse;
    Api.getOrders(20, paginationToken)
      .then(ordersResponse => {
        currentOrdersResponse.orders = currentOrdersResponse.orders.concat(ordersResponse.orders);
        Object.assign(currentOrdersResponse.products, ordersResponse.products);
        Object.assign(currentOrdersResponse.brands, ordersResponse.brands);
        ordersResponse.retailers.forEach(retailer => {
          currentOrdersResponse.retailers[retailer.token] = retailer
        });
        ordersResponse.users.forEach(user => {
          currentOrdersResponse.users[user.token] = user
        });

        this.setState({ordersResponse: currentOrdersResponse});

        if (ordersResponse.next_page_token) {
          this.loadOrders(ordersResponse.next_page_token);
        }
      })
      .catch(error => {
        this.setState({error});
      });
  }

  onChange(event) {
    let payload = {};
    payload[event.target.name] = event.target.value;
    this.setState(payload)
  }

  render() {
    if (this.state.error) {
      console.error(this.state.error);
      return <div className="error">Error: {this.state.error.message}</div>;
    }

    let orders;
    if (!this.state.ordersResponse.orders || this.state.ordersResponse.orders.length === 0) {
      orders = <FontAwesome name="refresh" spin/>;
    } else {
      let orderList = this.state.ordersResponse.orders;

      // Filter retailer
      if (this.state.retailerFilter) {
        orderList = orderList.filter(order => {
          return (order.retailer_token === this.state.retailerFilter);
        });
      }

      // Filter brand
      if (this.state.brandFilter) {
        orderList = orderList.filter(order => {
          let i;
          for (i = 0; i < order.items.length; i++) {
            if (order.items[i].brand_token === this.state.brandFilter) return true;
          }

          return false;
        });
      }

      orders = orderList.map((order) => {
        return <OrderItem key={order.token} order={order}
                          retailer={this.state.ordersResponse.retailers[order.retailer_token]}
                          user={this.state.ordersResponse.users[order.user_token]}
                          reloadOrders={this.reloadOrders}/>
      });
    }

    let retailerFilter = null;
    if (this.state.ordersResponse.retailers) {
      let retailerOptions = [<option key='retailerfilter-option-none' value="">-</option>];

      let retailerList = Object.keys(this.state.ordersResponse.retailers)
        .map(retailerToken => {
            return this.state.ordersResponse.retailers[retailerToken];
          }
        );

      retailerList
        .sort((a, b) => {
          return a.name.localeCompare(b.name);
        })
        .forEach(
          retailer => {
            retailerOptions.push(
              <option key={'retailerfilter-option-' + retailer.token} value={retailer.token}>
                {retailer.name}
              </option>
            );
          }
        );
      retailerFilter =
        <span><label>Retailer</label> <select name="retailerFilter" onChange={this.onChange}>{retailerOptions}</select></span>;
    }

    let brandFilter = null;
    if (this.state.ordersResponse.brands) {
      let brandOptions = [<option key='brandfilter-option-none' value="">-</option>];

      let brandList = Object.keys(this.state.ordersResponse.brands).map(
        brand_key => {
          return this.state.ordersResponse.brands[brand_key];
        }
      );

      brandList
        .sort((a, b) => {
          return a.name.localeCompare(b.name);
        })
        .forEach(
          brand => {
            brandOptions.push(
              <option key={'brandFilter-option-' + brand.token} value={brand.token}>
                {brand.name}
              </option>
            );
          }
        );
      brandFilter =
        <span><label>Brand</label> <select name="brandFilter" onChange={this.onChange}>{brandOptions}</select></span>;
    }

    return (
      <div className="order-list">
        <AdminTitle title="Placed Orders"/>
        <div className="order-filter">
          {retailerFilter}
          {brandFilter}
        </div>
        {orders}
      </div>
    );
  }
}

export class OrderItem extends React.Component {
  constructor(props) {
    super(props);

    this.onCancelOrder = this.onCancelOrder.bind(this);
    this.getCancelOrderSpan = this.getCancelOrderSpan.bind(this);
  }

  onCancelOrder() {
    let orderAmount = parseFloat(this.props.order.total_amount_cents / 100);
    let retailer = this.props.retailer;

    let choice = confirm("Are you sure you want to CANCEL the $" + orderAmount + " order for " + retailer.name + "?");
    if (choice === true) {
      Api.cancelOrder(this.props.order.token)
        .then(
          () => {
            return this.props.reloadOrders();
          },
          (error) => {
            alert('Error canceling order: ' + error.message);
          }
        );
    }
  }

  getCancelOrderSpan() {
    if (this.props.order.state === 'CANCELED' || this.props.order.state === 'FAILED') return <span className="cancel"/>;

    for (let i = 0; i < this.props.order.items.length; i++) {
      let item = this.props.order.items[i];
      if (item.state !== 'WAITING_ON_ORDER' && item.state !== 'CANCELED') return <span className="cancel"/>;
    }

    return (
      <span className="cancel" onClick={this.onCancelOrder}>
        <FontAwesome name="remove"/>
      </span>
    );
  }

  render() {
    let order = this.props.order;
    if (!order) return null;

    let retailer = this.props.retailer;
    let user = this.props.user;
    let cancelOrder = this.getCancelOrderSpan();
    let orderTotalCents = order.items_amount_cents;
    if (order.shipping_amount_cents) orderTotalCents += order.shipping_amount_cents;
    if (order.total_amount_cents) orderTotalCents += order.total_amount_cents;

    let orderDate = moment(order.created_at);

    return (
      <div className="order-list-entry">
        <span className="retailer">
          <Link to={`/admin/orders/${order.token}`}>{retailer.name}</Link>
        </span>
        <span className="user">{user.name}</span>
        <span className="itemcount">{order.items.length} items</span>
        <span className="orderdate">{orderDate.format('MMM Do YY')}</span>
        <span className="state">{order.state}</span>
        <span className="price">${parseFloat(orderTotalCents / 100).toFixed(2)}</span>
        {cancelOrder}
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/views/admin/Orders.js
 **/